<template>
  <div class="flex flex-col md:px-0 md:max-w-580 mx-auto">
    <div class="p-24 sm:bg-foreground sm:mt-24 sm:box-shadow-static-sm sm:rounded-xl">
      <ScreeningToolsIllustration class="mx-auto mb-24" />
      <h2 class="text-h3 mb-24">Your Adventure wasn't approved</h2>
      <p class="text-strong-body mb-8">What are some reasons Adventures aren't approved?</p>
      <ul class="mb-16">
        <li v-for="(listItem, index) in requiredList" :key="index" class="flex text-body mb-8">
          <CloseIcon :width="16" :height="16" color="#CE1B04" aria-hidden="true" class="mt-4 mr-8" />
          <span class="w-full">{{ listItem }}</span>
        </li>
      </ul>
      <p class="text-strong-body mb-8">What's next?</p>
      <ul class="mb-16">
        <li v-for="(listItem, index) in nextStepsList" :key="index" class="flex text-body mb-8">
          <TickIcon color="#229150" aria-hidden="true" class="mt-4 mr-8" />
          <span>{{ listItem }}</span>
        </li>
      </ul>
      <div
        class="w-full mt-8 sm:mt-0 fixed sm:static bottom-0 left-0 p-16 sm:p-0 border-t-1 border-solid border-grey-divider-subdued bg-foreground sm:border-0"
      >
        <Button value="Done" size="medium" class="w-full mb-16" href="/adventures" />
        <Button
          value="Contact Us"
          size="medium"
          variant="outlined"
          class="w-full"
          href="https://support.sittercity.com/hc/en-us/requests/new"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import ScreeningToolsIllustration from '@/graphics/illustrations/ScreeningToolsIllustration.vue';
import CloseIcon from '@/graphics/icons/CloseIcon.vue';
import TickIcon from '@/graphics/icons/TickIcon.vue';

export default {
  name: 'ReviewRejected',
  components: { Button, ScreeningToolsIllustration, CloseIcon, TickIcon },
  computed: {
    requiredList(): Array<any> {
      return ['Personal information like email or phone number detected', 'Spam detected', 'Profanity detected'];
    },
    nextStepsList(): Array<any> {
      return ['Create a new Adventure', 'Reach out to our Customer Success team'];
    },
  },
};
</script>
